import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './mobile/mobile.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import initialiseInterceptor from './api/interceptor';
import {registerServiceWorker} from './firebase';

// (Status bar left at the platform/native default — same as the vendor app —
// so the top strip blends with the app background instead of showing a seam.)

initialiseInterceptor();
// Register service worker only for web (not for native platforms)
registerServiceWorker().catch(err => {
    // Silently handle errors to prevent app crash
    console.log('Service worker registration skipped or failed:', err);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
